export default "__VITE_ASSET__6f3894c0__"